import React from "react";

interface FirmwareVersionEntry {
  name?: string;
  version?: string;
  description?: string;
  releaseDate?: string | Date;
}

// Read-only firmware listing for device types that don't support queued updates from this app.
export default function FirmwareVersionList({
  modelType,
  firmwares,
}: {
  modelType: string;
  firmwares: FirmwareVersionEntry[];
}) {
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 18, fontWeight: 500 }}>{modelType}</div>
      <div style={{ fontSize: 12, color: "gray", marginBottom: 8 }}>
        Firmware updates aren&apos;t supported for this device type. Available versions are shown
        for reference only.
      </div>
      {firmwares.length === 0 ? (
        <div style={{ fontSize: 13, color: "gray" }}>No firmware versions available.</div>
      ) : (
        <table className="table table-condensed" style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th>Version</th>
              <th>Description</th>
              <th>Release Date</th>
            </tr>
          </thead>
          <tbody>
            {firmwares.map((firmware) => (
              <tr key={firmware.name ?? firmware.version}>
                <td>{firmware.version}</td>
                <td>{firmware.description}</td>
                <td>
                  {firmware.releaseDate
                    ? new Date(firmware.releaseDate).toLocaleDateString()
                    : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
